import coreApiClient from "core-api"
import moment from "moment"
import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    startedAt: null,
    workspaceId: null,
    availabilities: {},
    availableReasons: [],
    selectedDate: null,
    selectedTime: null,
    selectedReasons: null,
    plateNumber: null,
    firstname: null,
    lastname: null,
    email: null,
    phoneNumber: null
  }
}

const state = getDefaultState()

const getters = {
  getAvailableDates(state) {
    let dates = Object.keys(state.availabilities)
    dates.sort()
    return dates
  },

  getAvailableTimes: state => date => {
    return state.availabilities[date] || []
  },

  getFirstAvailableDate(state, getters) {
    let dates = getters.getAvailableDates
    return dates.length ? dates[0] : null
  },

  getSelectedReasons(state) {
    let availableReasons = Array.prototype.concat.apply([], state.availableReasons.map(elem => elem.actions))

    let reasons = []
    state.selectedReasons.forEach(id => {
      let reason = availableReasons.find(elem => elem.id === id)
      if (reason) {
        reasons.push(reason)
      }
    })

    return reasons
  }
}

const mutations = {
  setStartedAt(state, payload) {
    state.startedAt = payload
  },
  setWorkspaceId(state, payload) {
    state.workspaceId = payload
  },
  setAvailabilities(state, payload) {
    state.availabilities = payload
  },
  setSelectedDate(state, payload) {
    state.selectedDate = payload
  },
  setAvailableTimes(state, payload) {
    state.availableTimes = payload
  },
  setSelectedTime(state, payload) {
    state.selectedTime = payload
  },
  setAvailableReasons(state, payload) {
    state.availableReasons = payload
  },
  setSelectedReasons(state, payload) {
    state.selectedReasons = payload
  },
  setPlateNumber(state, payload) {
    state.plateNumber = payload
  },
  setFirstname(state, payload) {
    state.firstname = payload
  },
  setLastname(state, payload) {
    state.lastname = payload
  },
  setEmail(state, payload) {
    state.email = payload
  },
  setPhoneNumber(state, payload) {
    state.phoneNumber = payload
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  loadAvailabilities(context) {
    let startDate = moment().add(1, "days")
    let endDate = moment(startDate).add(1, "months")
    return coreApiClient.workspaces.getAvailabilities(
      context.state.workspaceId,
      startDate.format("YYYY-MM-DD"),
      endDate.format("YYYY-MM-DD"))
      .then(response => {
        context.commit("setAvailabilities", response)
        return response
      })
      .catch(error => {
        window.console.error(error)
        return Promise.reject(error)
      })
  },
  loadAvailableReasons(context) {
    return coreApiClient.workspaces.getAvailableReasons(context.state.workspaceId)
      .then(response => {
        context.commit("setAvailableReasons", response)
        return response
      })
      .catch(error => {
        window.console.error(error)
        return Promise.reject(error)
      })
  },
  storeAppointment({
    state, getters
  }) {
    let actions = getters.getSelectedReasons.map(elem => {
      return {
        id: elem.id,
        name: elem.name,
        duration: elem.duration
      }
    })

    let payload = {
      firstname: state.firstname,
      lastname: state.lastname,
      email: state.email,
      phoneNumber: state.phoneNumber,
      date: `${state.selectedDate} ${state.selectedTime}`,
      plateNumber: state.plateNumber,
      actions: actions
    }

    return coreApiClient.workspaces.storeAppointment(state.workspaceId, payload)
      .then(response => {
        return response
      })
      .catch(error => {
        window.console.error(error)
        return Promise.reject(error)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}